module.exports = __webpack_public_path__ + "img/12.88765b0e.png";